import { FC } from 'react';

import Introduction from '../../../Shared/Introduction';

import { Product, Content } from '../../../../types/tour';

export type Props = {
  content: Content;
  setComplete: () => void;
  goNext: () => void;
  image?: string;
};

export const Step1: FC<Props> = ({ image, setComplete, goNext, content }) => {
  const initTour = () => {
    setComplete();
    goNext();
  };

  return (
    <Introduction
      setComplete={initTour}
      product={Product.Video}
      title={content.title}
      icon={content.icon}
      subtitle={content.paragraphs}
      image={
        <img src={image} alt={content.title} className="hidden md:block" />
      }
      noAuth={true}
    />
  );
};
